import { useState } from 'react';

export const SORT_TYPES = {
  NULL: 'NULL',
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
export type SortTypes = keyof typeof SORT_TYPES;

export const useSorting = () => {
  const [sort, setSort] = useState<SortTypes>(SORT_TYPES.NULL);

  const updateSorting = () => {
    setSort((prevState) =>
      prevState === SORT_TYPES.ASC
        ? SORT_TYPES.NULL
        : prevState === SORT_TYPES.NULL
          ? SORT_TYPES.DESC
          : SORT_TYPES.ASC,
    );
  };

  return {
    sort,
    updateSorting,
  };
};
